import React from "react"
import PropTypes from "prop-types"
import {
  VACATION_DAY_TYPES,
  VACATION_DAYS_VARIANTS,
} from "../../../consts/modules/vacations.consts"
import VacationDayVariantChip from "../../../components/molecules/VacationDayVariantChip.molecule"

const VacationDayTypesBreakdown = ({
  vacationRequest,
  chipProps = {
    showQuantity: true,
  },
}) => {
  return (
    <div className="vacation-daytypes-breakdown flex gap-2">
      {vacationRequest?.numberOfBucketDays > 0 && (
        <VacationDayVariantChip
          variant={VACATION_DAYS_VARIANTS.LONG}
          dayType={VACATION_DAY_TYPES.BUCKET}
          quantity={vacationRequest.numberOfBucketDays}
          {...chipProps}
        />
      )}
      {vacationRequest?.numberOfPlusDays > 0 && (
        <VacationDayVariantChip
          variant={VACATION_DAYS_VARIANTS.LONG}
          dayType={VACATION_DAY_TYPES.PLUS}
          quantity={vacationRequest.numberOfPlusDays}
          {...chipProps}
        />
      )}
      {vacationRequest?.numberOfAccordedDays > 0 && (
        <VacationDayVariantChip
          variant={VACATION_DAYS_VARIANTS.LONG}
          dayType={VACATION_DAY_TYPES.ACCORDED}
          quantity={vacationRequest.numberOfAccordedDays}
          {...chipProps}
        />
      )}
      {vacationRequest?.numberOfAdditionalDays > 0 && (
        <VacationDayVariantChip
          variant={VACATION_DAYS_VARIANTS.LONG}
          dayType={VACATION_DAY_TYPES.EXTRA}
          quantity={vacationRequest.numberOfAdditionalDays}
          {...chipProps}
        />
      )}
    </div>
  )
}

export default VacationDayTypesBreakdown

VacationDayTypesBreakdown.propTypes = {
  vacationRequest: PropTypes.shape({
    numberOfBucketDays: PropTypes.number,
    numberOfPlusDays: PropTypes.number,
    numberOfAdditionalDays: PropTypes.number,
  }),
  chipProps: PropTypes.shape({
    showQuantity: PropTypes.bool,
  }),
}
